let rootUrl = "/driverportal/:customer";

export const Routes = {
  ROOT: rootUrl,
  LOGIN: rootUrl + "/login",
  SECURITY: rootUrl + "/securitypage",
  FORGETPASSWORD: rootUrl + "/forgetpassword",
  FORGETUSERNAME: rootUrl + "/forgetusername",
  DASHBOARD: rootUrl + "/dashboard",
  VERIFYDASHBOARD: rootUrl + "/verify-dashboard",
  REGISTRATION: rootUrl + "/register",
  REGISTRATIONSUCCESS: rootUrl + "/register/success",
  RESETPASSWORD: rootUrl + "/resetpassword/:name",
  RESETPASSWORDSTATUS: rootUrl + "/forget-password/status",
  RESETUSERNAMESTATUS: rootUrl + "/forget-username/status",
  PRIVACY: rootUrl + "/privacy",
  PCICOMPLIANCE: rootUrl + "/pciCompliance",
  PAYCITATION: rootUrl + "/paycitation",
  RESETPASSWORDSUCCESS: rootUrl + "/reset-password/success",
  PROFILEPAGE: rootUrl + "/profile",
  CITATION: rootUrl + "/citation",
  PAYCITATIONFORMPAGE: rootUrl + "/paycitation-form",
  CITATIONDETAILS: rootUrl + "/citation-details/:citationId/:licenseId",
  CITATIONDETAILSPDF: rootUrl + "/citation-actions/download-citation/:ClientName/:citationId",
  CITATIONPAYMENTSTATUS: rootUrl + "/citation-payment/status",
  VIEWORDERS: rootUrl + "/vieworders",
  BUYPERMITS: rootUrl + "/buyPermits",
  PERMIT_PAYMENT_STATUS: rootUrl + "/permit-payment-status",
  VERIFYEMAIL: rootUrl + "/email-status/:clientUsername",
  VISITORPERMIT: rootUrl + "/visitorPermit",
  VISITORPERMITFORM: rootUrl + "/visitorPermitForm",
  INCOMPLETEPAYMENT: rootUrl + "/incompletePayment",
};
export const RouteService = {
  login: (customerName) => {
    return `/driverportal/${customerName}/login`;
  },
  home: (customerName) => {
    return `/driverportal/${customerName}`;
  },
  incompletePayment: (customerName) => {
    return `/driverportal/${customerName}/incompletePayment`;
  },
  forgetPassword: (customerName) => {
    return `/driverportal/${customerName}/forgetpassword`;
  },
  forgetUserName:(customerName)=>{
    return `/driverportal/${customerName}/forgetusername`;
  },
  resetPassword: (customerName) => {
    return `/driverportal/${customerName}/resetpassword`;
  },
  resetPasswordStatus: (customerName) => {
    return `/driverportal/${customerName}/forget-password/status`;
  },
  resetUsernameStatus: (customerName) => {
    return `/driverportal/${customerName}/forget-username/status`;
  },
  registrationSuccess: (customerName) => {
    return `/driverportal/${customerName}/register/success`;
  },
  registration: (customerName) => {
    return `/driverportal/${customerName}/register`;
  },
  dashboard: (customerName) => {
    return `/driverportal/${customerName}/dashboard`;
  },
  verifyDashboard: (customerName) => {
    return `/driverportal/${customerName}/verify-dashboard`;
  },
  payCitation: (customerName) => {
    return `/driverportal/${customerName}/paycitation`;
  },
  citation: (customerName) => {
    return `/driverportal/${customerName}/citation`;
  },
  resetPasswordSuccess: (customerName) => {
    return `/driverportal/${customerName}/reset-password/success`;
  },
  profilePage: (customerName) => {
    return `/driverportal/${customerName}/profile`;
  },
  viewOrders: (customerName) => {
    return `/driverportal/${customerName}/vieworders`;
  },
  securityPage: (customerName) => {
    return `/driverportal/${customerName}/securitypage`
  },
  buyPermits: (customerName) => {
    return `/driverportal/${customerName}/buyPermits`;
  },
  permitPaymentStatus: (customerName) => {
    return `/driverportal/${customerName}/permit-payment-status`;
  },
  verifyEmail: (customerName) => {
    return `/driverportal/${customerName}/email-status`;
  },
  visitorPermit: (customerName) => {
    return `/driverportal/${customerName}/visitorPermit`;
  },
  visitorPermitForm: (customerName) => {
    return `/driverportal/${customerName}/visitorPermitForm`;
  },
  payCitationForm: (customerName) =>
    `/driverportal/${customerName}/paycitation-form`,
  citationDetails: (customerName) =>
    `/driverportal/${customerName}/citation-details`,
  citationPaymentStatus: (customerName) =>
    `/driverportal/${customerName}/citation-payment/status`,
  citationDetail: (customerName, licenseId, citationId) =>
    `/driverportal/${customerName}/citation-details/${licenseId}/${citationId}`,
  citationDetailPDF: (customerName, ClientName, citationId) =>
    `/driverportal/${customerName}/citation-actions/download-citation/${ClientName}/${citationId}`,
};
